import React from "react";
import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";

const initForm = Object.freeze({
   color: "",
   descripcion: "",
});

const FormColor = (props) => {
   const { fn } = props;
   const [form, setForm] = useState(initForm);

   const handleChange = (e) => {
      setForm({
         ...form,
         [e.target.name]: e.target.value,
      });
   };

   const submit = function (e) {
      e.preventDefault();
      console.log(form);
      axios
         .post(API_URL + "/setColor", { ...form })
         .then((r) => {
            console.log(r.data);
            setForm(initForm);
            fn();
         })
         .catch((e) => console.log(e));
   };

   return (
      <div>
         <form className="w-full max-w-lg" onSubmit={submit}>
            <div className="flex flex-wrap -mx-3 mb-6">
               <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Color:</label>
                  <input
                     className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     name="color"
                     type="text"
                     value={form.color}
                     onChange={handleChange}
                  />
               </div>
               <div className="w-full md:w-1/2 px-3">
                  <label
                     className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                     htmlFor="grid-last-name"
                  >
                     Descripción:
                  </label>
                  <input
                     className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                     name="descripcion"
                     type="text"
                     value={form.descripcion}
                     onChange={handleChange}
                  />
               </div>
            </div>
            <button type="submit" className="bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow">
               Guardar Color
            </button>
         </form>
         {/*<PickColor />*/}
      </div>
   );
};

export default FormColor;
